import { LicensingModalType } from "./licensing.types";
const state = {
    licenses: null,
    serialNumber: null,
    licensingModalOpen: false,
    licensingModalType: LicensingModalType.LIST,
    serverError: null,
    capabilityRequestError: null,
    seats: { availableSeats: 0, busySeats: 0, isLastSeat: false },
    noSeatsAvailableToastVisible: false,
    seatToastVisibleStatus: false,
    deactivationFinished: null,
};
export default state;
